<template>
<div class="chapter">
<div class="inner_page">
<p class="center-paraa"><a id="page_i"></a><strong>Bloody Piracy!</strong></p>
<p class="para">The French patrol copters tried hailing the Danish cargo carrier <em>Dolphin</em>, but to no avail.</p>
<p class="indent-para">When the helicopter reached the <em>Dolphin</em>, it found the vessel still afloat but obviously not under control. Three armed crewmen rappelled down to the ship. One of them lost his footing and fell. Pulling himself to his feet he realized to his horror that the slick substance covering the deck was blood. Walking more carefully now, he and the other French sailors searched high and low but could find no sign of the ship’s crew.</p>
<p class="indent-para">The cargo of cheap furniture and electronics was intact. There was a large empty space in the hold, as if <em>something</em> had been taken. Also, the ship’s bridge had been stripped of its GPS system, its satellite phones, its fax machine and its weather computer.</p>
<p class="indent-para">After the men finished their fruitless, dispiriting search they returned to the helicopter and flew back to their ship in dazed silence. The French had been doing anti-pirate duty in these waters for more than a year, and while they’d seen their share of incidents, those incidents were <em>always</em> just hijacking attempts—not willful killings or the intentional sinking of ships.</p>
<p class="indent-para">In just one night, the pirate problem in the Gulf of Aden had become a lot more dangerous.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter.vue?97a5e556